import 'vue3-carousel/carousel.css'
import './assets/main.css'

import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import { i18n, localeNames } from '@/i18n'

import useStrapiStore from '@/composition/strapiStore'

const pathLocale = window.location.pathname.split('/')[1] ?? ''
if (localeNames.includes(pathLocale)) {
  localStorage.setItem('user-locale', pathLocale)
}

const strapiStore = useStrapiStore()

await strapiStore.actions.loadPage('landing', true)

const app = createApp(App)
app.use(router).use(i18n)
app.mount('#app')
